module.exports = __webpack_public_path__ + "media/images/flags/md-01c760d56b1195ae64a2ae9c6caa4b86.svg";